import { LEGACY_UI_VALUE, parseRange } from "@/components/report/desktop/reportQuery";

export { buildWarehousePeriodPresets as buildRecipePeriodPresets } from "@/components/warehouse-shell/warehouseQuery";
export { LEGACY_UI_VALUE, parseRange };

/**
 * Stanje Recepata u adresi (hash router: /#/recipes?t=total&from=…&to=…&v=meal&s=12&p=1).
 * Danas, prvi tab, prikaz po većini firmi, sve smjene (1–3) i isključene cijene se izostavljaju.
 * Jela, pretraga i izmijenjene porcije nisu u adresi: važe samo dok je stranica otvorena.
 */
export const RECIPES_QUERY = {
  tab: "t",
  from: "from",
  to: "to",
  view: "v",
  shifts: "s",
  price: "p",
  legacy: "ui",
};

export const MANAGED_RECIPES_QUERY = [
  RECIPES_QUERY.tab,
  RECIPES_QUERY.from,
  RECIPES_QUERY.to,
  RECIPES_QUERY.view,
  RECIPES_QUERY.shifts,
  RECIPES_QUERY.price,
];

export const RECIPE_TABS = ["meals", "total"];
export const RECIPE_VIEWS = ["group", "meal"];
export const DEFAULT_RECIPE_TAB = "meals";
export const DEFAULT_RECIPE_SHIFTS = [1, 2, 3];
export const ALL_RECIPE_SHIFTS = [1, 2, 3, 4];

/** "12" → [1, 2]; neispravno ili prazno → null (ostaje podrazumijevano) */
export const parseRecipeShifts = (value) => {
  const list = [
    ...new Set(
      String(value || "")
        .split("")
        .map(Number)
        .filter((shift) => ALL_RECIPE_SHIFTS.includes(shift))
    ),
  ].sort();
  return list.length ? list : null;
};

export const serializeRecipeShifts = (shifts) => {
  const sorted = [...shifts].sort();
  return sorted.join("") === DEFAULT_RECIPE_SHIFTS.join("") ? undefined : sorted.join("");
};
